import clsx from 'clsx'
import { InputListDragable } from './Panels/AddInput'
import { Tab } from '@headlessui/react'
import { FaPlus } from 'react-icons/fa6'
import { BsFillLayersFill } from 'react-icons/bs'
import { MdDesignServices } from 'react-icons/md'

import { useState } from 'react'
import LayerPanel from './Panels/LayerPanel'
import DesignPanel from './Panels/DesignPanel'
import { useTranslation } from '../hooks/useTranslation'

type TabsType = {
  label: string
  icon?: React.ReactNode
  content: React.ReactNode
}

export default function LeftPanel(props: { leftPanelClassname?: string; componentPanelClassname?: string }) {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const { t } = useTranslation()

  const tabs: TabsType[] = [
    {
      label: 'Component',
      icon: <FaPlus />,
      content: <InputListDragable componentPanelClassname={props.componentPanelClassname} />,
    },
    {
      label: 'Layer',
      icon: <BsFillLayersFill />,
      content: <LayerPanel />,
    },
    {
      label: 'Design',
      icon: <MdDesignServices />,
      content: <DesignPanel />,
    },
  ]

  return (
    <div className={clsx(!props.leftPanelClassname && 'h-[calc(100vh-180px)]', props.leftPanelClassname)}>
      <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
        <Tab.List className="flex space-x-1 w-full rounded-lg bg-slate-100 sticky top-0 p-1.5">
          {tabs.map((item, index) => (
            <Tab
              key={item.label}
              className={({ selected }) =>
                clsx(
                  'rounded-lg py-2 px-3 w-full text-xs font-medium leading-5',
                  'focus:ring-0 focus:outline-none',
                  'transition-all duration-300 ease-in-out',
                  'hover:scale-105 transform',
                  selected ? 'bg-white text-black shadow scale-105' : 'text-black hover:text-slate-700'
                )
              }
            >
              <div className="flex items-center justify-center gap-1 transition-all duration-200">
                <span className="transition-transform duration-200 hover:scale-110">{item.icon}</span>
                {index === selectedIndex && <span className="animate-slide-in-right">{t(`panels.${item.label}`)}</span>}
              </div>
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-4">
          {tabs.map(({ label, content }) => (
            <Tab.Panel key={label} className="transition-al duration-300 ease-in-out border-0 outline-none">
              <div className="animate-fade-in">{content}</div>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  )
}
